import React from "react";
import { useNavigate } from "react-router-dom";
import { Star, Truck, CheckCircle2 } from "lucide-react";
import Layout from "../components/Layout";
import GlassCard from "../components/GlassCard";
import SectionHeader from "../components/SectionHeader";
import DepositButton from "../components/DepositButton";

const INCLUDED = [
  "One breeding attempt",
  "Professional semen collection",
  "Veterinary semen analysis & evaluation",
  "Extension & overnight-ready preparation",
  "Free repeat breeding if no conception",
];

const QUALIFICATIONS = [
  "Female must be AKC registered",
  "Current health testing on file",
  "Photos of your female",
];

export default function StudService() {
  const navigate = useNavigate();
  return (
    <Layout>
      <section className="py-20 md:py-24 px-6">
        <div className="max-w-6xl mx-auto">
          <SectionHeader label="Stud Service" title="Proven studs," highlight="proven results" />
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
            <GlassCard hover={false} className="p-8 text-center">
              <p className="kk-label mb-2">Starting Fee</p>
              <p className="font-display text-6xl font-bold text-[#BB0000] mb-1" data-testid="stud-price">$2,500</p>
              <p className="text-[#999999] text-sm mb-7">Shipping billed separately ($150–$300 typical)</p>
              <ul className="space-y-3 text-left mb-8">
                {INCLUDED.map((i) => (
                  <li key={i} className="flex items-center gap-3 text-[#E0E0E0] text-sm">
                    <Star size={18} className="text-[#BB0000] shrink-0" fill="#BB0000" /> {i}
                  </li>
                ))}
              </ul>
              <DepositButton packageId="stud_deposit" label="Pay $500 Stud Deposit" className="w-full mb-3" />
              <button onClick={() => navigate("/stud-waitlist")} className="kk-btn kk-btn-outline rounded-full px-8 py-4 w-full" data-testid="stud-join-waitlist">
                Request Stud Service
              </button>
            </GlassCard>

            <div className="space-y-6">
              <GlassCard hover={false} className="p-8">
                <h3 className="kk-heading text-2xl mb-4">Stud Details</h3>
                <p className="text-[#E0E0E0] leading-relaxed mb-3">
                  Our studs are fully health tested, AKC registered, and carry rare color genetics including Blue, Cocoa, Cream, Tan Points and Fluffy carriers. We ship chilled semen overnight anywhere in the U.S.
                </p>
                <div className="flex items-center gap-3 text-[#A8A9AD] text-sm">
                  <Truck size={18} className="text-[#BB0000]" /> Overnight chilled shipping, nationwide
                </div>
              </GlassCard>
              <GlassCard hover={false} className="p-8">
                <h3 className="kk-heading text-2xl mb-4">Qualifications</h3>
                <ul className="space-y-3">
                  {QUALIFICATIONS.map((q) => (
                    <li key={q} className="flex items-center gap-3 text-[#E0E0E0] text-sm">
                      <CheckCircle2 size={18} color="#4CAF50" className="shrink-0" /> {q}
                    </li>
                  ))}
                </ul>
              </GlassCard>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
